import { render, staticRenderFns } from "./DeepstreamEngine.vue?vue&type=template&id=a864be7e"
import script from "./DeepstreamEngine.vue?vue&type=script&lang=js"
export * from "./DeepstreamEngine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports